/* global Office */
export function getFileUrl(): Promise<string> {
  return new Promise((resolve) => {
    Office.context.document.getFilePropertiesAsync(null, (res) => {
      if (res && res.value && res.value.url) {
        let name = res.value.url.substr(res.value.url.lastIndexOf("\\") + 1);
        resolve(name);
      }
      resolve("");
    });
  });
}

export function getDocumentInfo() {
  return new Promise((resolve) => {
    Office.context.document.getFilePropertiesAsync(null, (res) => {
      resolve(res.value);
    });
  });
}

/**
 * Reads the document content as a Blob.
 * @returns {Promise<Blob>} A promise that resolves with the document content as a Blob.
 */
export function readDocumentBinary(): Promise<Blob> {
  return new Promise((resolve, reject) => {
    Office.context.document.getFileAsync(Office.FileType.Compressed, { sliceSize: 65536 }, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const file: Office.File = result.value;
        const sliceCount = file.sliceCount;
        const slices: Array<Uint8Array> = [];

        const getSlice = (sliceIndex: number) => {
          file.getSliceAsync(sliceIndex, (sliceResult) => {
            if (sliceResult.status === Office.AsyncResultStatus.Succeeded) {
              slices.push(new Uint8Array(sliceResult.value.data));
              if (sliceIndex < sliceCount - 1) {
                getSlice(sliceIndex + 1);
              } else {
                file.closeAsync();
                const blob = new Blob(slices, {
                  type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                });
                resolve(blob);
              }
            } else {
              file.closeAsync();
              reject(new Error("Failed to get file slice"));
            }
          });
        };

        getSlice(0);
      } else {
        reject(new Error("Failed to get file"));
      }
    });
  });
}
